/**
 * Hybrid realtime lifecycle — restarts when cloud_plan upgrades mid-session.
 */

import { useEffect } from 'react';
import { assertHybridSyncAllowed } from '../../../services/cloudCapability';

export const CLOUD_PLAN_CHANGED_EVENT = 'aman:cloud-plan-changed';

export function useHybridRealtimeLifecycle({ enabled, businessId }) {
  useEffect(() => {
    if (!enabled || !businessId) {
      void import('../../../services/hybridRealtime').then(({ stopHybridRealtime }) =>
        stopHybridRealtime()
      );
      return undefined;
    }

    let cancelled = false;

    const tryStart = () => {
      if (cancelled) return;
      if (!assertHybridSyncAllowed(businessId).allowed) {
        void import('../../../services/hybridRealtime').then(({ stopHybridRealtime }) =>
          stopHybridRealtime()
        );
        return;
      }
      void import('../../../services/hybridRealtime').then(({ startHybridRealtime }) =>
        startHybridRealtime(businessId)
      );
    };

    tryStart();

    const onOnline = () => tryStart();
    const onPlan = () => tryStart();
    window.addEventListener('online', onOnline);
    window.addEventListener(CLOUD_PLAN_CHANGED_EVENT, onPlan);

    return () => {
      cancelled = true;
      window.removeEventListener('online', onOnline);
      window.removeEventListener(CLOUD_PLAN_CHANGED_EVENT, onPlan);
      void import('../../../services/hybridRealtime').then(({ stopHybridRealtime }) =>
        stopHybridRealtime()
      );
    };
  }, [enabled, businessId]);
}
